import React from 'react';
import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import ContractEnergyDTO from 'features/contracts/dtos/ContractEnergyDTO';
import ContractDetailLayoutPage from './ContractDetailLayoutPage';
import ReservedCapacitySection from '../sections/ReservedCapacitySection';
import { useTranslation } from 'react-i18next';


interface Props {
  contract: ContractFullDTO;
  contractEnergy: ContractEnergyDTO;
}

const ReservedCapacityPage = ({ contract, contractEnergy }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // render
  return (
    <ContractDetailLayoutPage
      contract={contract}
      contractEnergy={contractEnergy}
      links={[{ text: tLabels("reservedCapacityPage.title") }]}
    >
      <ReservedCapacitySection
        contract={contract}
      />
    </ContractDetailLayoutPage>
  )
}

export default ReservedCapacityPage;